/**
 * ViewToggle - Alterna entre visualização em Grade e Lista
 */
import React from 'react';
import { Button } from './button';
import { LayoutGrid, List } from 'lucide-react';

export const ViewToggle = ({ viewMode, setViewMode, className = '' }) => {
  return (
    <div className={`flex items-center border rounded-lg overflow-hidden ${className}`} data-testid="view-toggle">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setViewMode('grid')}
        className={`rounded-none h-8 px-3 ${viewMode === 'grid' ? 'bg-blue-50 text-blue-600' : 'text-gray-500'}`}
        data-testid="view-toggle-grid"
        title="Visualização em grade"
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setViewMode('list')}
        className={`rounded-none h-8 px-3 ${viewMode === 'list' ? 'bg-blue-50 text-blue-600' : 'text-gray-500'}`}
        data-testid="view-toggle-list"
        title="Visualização em lista"
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ViewToggle;
